<template>
  <section class="wrap">
    <div class="mobile_wrap">
      <header class="nav">
        <img src="@/assets/recipe_logo.png" alt="logo" />
      </header>
      <div>
        <template v-for="item in list">
          <!-- {{item}} -->
          <div class="recipe_card" v-if="item.type==`recipe`" @click="handleRecipeClick(item.id)">
            <div class="detail">
              <p class="ago">{{ item.ago }}</p>
              <h4 v-html="item.name"/>
              <p class="user">{{ item.member_name }}</p>
              <ul class="sub_info">
                <li><strong>추천</strong><span v-html="item.like_count" /></li>
                <li><strong>댓글</strong><span v-html="item.reply_count" /></li>
                <li><strong>조회</strong><span v-html="item.view_count" /></li>
              </ul>
            </div>
            <div class="img_cover">
              <img class="image" :src="item.image" alt="레시피 이미지"/>
            </div>
            
          </div>
          <div class="hot_recipe_wrap" v-if="item.type ==`new10_recipe`">
            <h3>요즘 뜨는 레시피</h3>
            <swiper 
              :slidesPerView="'auto'"
              :spaceBetween="16"
              :pagination="{
                clickable: true,
              }"
            class="mySwiper">
                <swiper-slide v-for="new_item in item.new10_list">
                  <div class="hot_recipe_card" @click="handleRecipeClick(new_item.id)">
                    <div class="img_cover">
                      <img class="image" :src="new_item.image" alt="레시피 이미지"/>
                    </div>
                    <h4 v-html="new_item.name"/>
                    <div class="sub_info"><strong>추천</strong><span v-html="new_item.like_count" /></div>
                  </div>
                </swiper-slide>
            </swiper>
          </div>
        </template>
        
        <!-- https://todaymeal.page.link/recipe -->
        <Loading v-if="loading" />
        <div ref="scrollArea" />
      </div>
      <button class="app_link" @click="handleLinkClick">오늘집밥 앱으로 보기</button>
    </div>
    <div class="bg"></div>
    <img class="bg2" src="@/assets/recipe_bg.png" alt="오늘집밥 캐릭터 이미지"/>
    
  </section>
</template>

<script>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useStore } from 'vuex'

import client from "../client/client";
import Loading from "../components/Loading";
import { useRoute } from 'vue-router'

import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';

export default {
  name: "RecipeIntroduceMain",
  components: {
    Loading,
    Swiper,
    SwiperSlide,
  },
  setup() {
    const store = useStore();
    const recipeLists = computed(() => store.getters.recipeLists);
    const recipePage = computed(() => store.getters.recipePage);

    const scrollArea = ref(null);
    const list = ref(recipeLists.value);
    const page = ref(recipePage.value);
    const loading = ref(false)
    const hasMore = ref(true);

    const loadMore = async () => {
      if (loading.value || !hasMore.value) {
        return;
      }

      loading.value = true
      const response = await client.web_get(`/api/new/recipe/list?type=recent&page=${page.value}`);
      if(!response.r) {
        loading.value = true;
        return alert('일시적 오류가 발생하였습니다 다시 시도해주세요');
      }
        
      const newItems = response.list

      if (newItems.length === 0) {
        hasMore.value = false
      } else {
        if(page.value == 0) {
          const array = response.list;
          const new10_item = { type: 'new10_recipe', new10_list: response.new10_list };
          const array1 = array.slice(0, 2);
          const array2 = array.slice(2);

          array1.forEach(item => list.value.push(item));
          list.value.push(new10_item);
          array2.forEach(item => list.value.push(item));

        } else {
          list.value = [...list.value, ...newItems];  
        }
        page.value += 1
        store.dispatch('isRecipePageUpdate', page.value);
        store.dispatch('isRecipeListsUpdate', list.value);
      }

      loading.value = false
    }

    const observer = new IntersectionObserver(
      async (entries) => {
        const target = entries[0].target;
        if (entries[0].isIntersecting && !loading.value && hasMore.value) {
          await loadMore();
          // observer.observe(target);
        }
      },
      { threshold: 0.5 }
    );

    onMounted(() => {
      observer.observe(scrollArea.value)
    })

    onUnmounted(() => {
      observer.disconnect();
    });

    return {
      scrollArea,
      list,
      loading,
      hasMore,
    };
  },

  data: function () {
    const route = useRoute()
    const { query } = route;
    return {
      // loading: true,
      query: query,
    };
  },
  methods: {
    handleSlideChange(swiper) {
      if(swiper.translate < - 1300) {
        return swiper.slideTo(0);
      }
    },

    async update() {
      const route = useRoute()
      const { query } = route;
      // client.updateToken(query);
    },

    handleLinkClick() {
      window.open('https://todaymeal.page.link/recipe', '_blank');
    },

    handleRecipeClick(id) {
      window.location.href = `https://m.oh-bab.com/recipe/recipe_${id}.html`;
      // this.$router.push(`/recipeDetail/?id=${id}`);
    },
  },
  async mounted() {
    this.update();
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/icon.scss";
@import "../assets/scss/base.scss";
.app_link {
  background: #F2632A;
  border-radius: 10px;
  width: calc(100% - 30px);
  max-width: 600px;
  position:fixed;
  bottom:30px;
  font-size: 18px;
  color: #FFFFFF;
  z-index: 999;
  border:0;
  left:50%;
  transform: translateX(-50%);
  padding:20px 4px;
}
.mt12{
  margin-top:12px !important;
}
body {
  background-color: #DEDEDE !important;
}
.bg {
  z-index: 1;
  position: fixed;
  top:0;
  left:0;
  right: 0;
  bottom: 0;
  background: #DEDEDE;
}
.bg2 {
  z-index: 1;
  position: fixed;
  top:50%;
  left:70%;
  transform: translateY(-50%);
  width:395px;
}
.nav {
  padding:21px 16px 18px;
  border-bottom: 1px solid #F2F2F2;
  img {
    width: 158px;
  }
}
.wrap {
  width: 100%;
}
.mobile_wrap {
  position: relative;
  z-index: 2;
  max-width: 640px;
  width: 100%;
  margin: 0 auto;
  background: #fff;
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.1);
  padding-bottom:82px;
  > div {
    display: flex;
    flex-direction: column;
    // min-height: 100vh;
  }
}
.recipe_card {
  display: flex;
  padding:20px 16px;
  border-bottom: 1px solid #F4F4F4;
  cursor: pointer;
  .detail {
    display: flex;
    flex-direction: column;
    h4 {
      font-size:16px;
      color:#000;
      margin-bottom: 8px;
    }
    .user {
      font-size: 12px;
      color:#656565;
      margin-bottom: 2px;
      margin-top: auto;
    }
    .ago {
      font-size: 12px;
      color:#656565;
      margin-bottom: 2px; 
    }
    .sub_info {
      list-style: none;
      margin:0;
      padding:0;
      display: flex;
      li {
        padding-right: 12px;
        strong {
          font-size: 12px;
        }
        span {
          font-size: 12px;
          margin-left:4px;
          font-weight: bold;
          color:#F2632A;
        }
      }
    }
  }
  .img_cover {
    max-width: 160px;
  }
}

.img_cover {
  margin-left: auto;
  max-width: 240px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  width: 100%;
  overflow: hidden;
  min-height: 120px;
  aspect-ratio: 1 / 1;
  img {
    width: 100%;
    height: 100%;
    object-fit:cover;
  }
}

.hot_recipe_wrap {
  background: #F4F4F4;
  padding:24px 18px;
  .hot_recipe_card {
    cursor: pointer;
    max-width: 120px;
    height:200px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    h4 {
      font-size:14px;
      color:#000;
      word-break: keep-all;
    }
    .sub_info {
      font-size:12px;
      margin-top:auto;
      span {
        font-size: 12px;
        margin-left:4px;
        font-weight: bold;
        color:#F2632A;
      }
    }
  }
}

.swiper {
  width: 100%;
}
.swiper-slide {
  width: 120px !important;
}


</style>
